import { render, staticRenderFns } from "./SoftwareScreen.vue?vue&type=template&id=3bf15f74&scoped=true&"
import script from "./SoftwareScreen.vue?vue&type=script&lang=js&"
export * from "./SoftwareScreen.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareScreen.vue?vue&type=style&index=0&id=3bf15f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf15f74",
  null
  
)

export default component.exports